module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "todolist"
  }, [_vm._h('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.agregarTarea(_vm.nuevaTarea)
      }
    }
  }, [_vm._h('div', {
    staticClass: "input-group"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevaTarea),
      expression: "nuevaTarea"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "placeholder": "Edite una tarea..."
    },
    domProps: {
      "value": _vm._s(_vm.nuevaTarea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nuevaTarea = $event.target.value
      }
    }
  }), " ", _vm._h('span', {
    staticClass: "input-group-btn"
  }, [_vm._h('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !this.$store.state.autentificado,
      "type": "submit"
    }
  }, ["Agregar tarea"])])])]), " ", _vm._m(0), " ", _vm._l((_vm.tareas), function(tarea, index) {
    return _vm._h('div', {
      staticClass: "card"
    }, [_vm._h('div', {
      staticClass: "card-block"
    }, [_vm._h('h5', {
      staticClass: " card-title",
      class: {
        completado: tarea.completado
      }
    }, [_vm._h('img', {
      staticClass: "avatar",
      staticStyle: {
        "margin.right": "15px",
        "border-radius": "4px"
      },
      attrs: {
        "src": tarea.avatar,
        "height": "32px",
        "width": "32px"
      }
    }), "\n        " + _vm._s(tarea.titulo) + "\n        ", _vm._h('small', {
      staticStyle: {
        "font-size": "12px"
      }
    }, ["(" + _vm._s(tarea.nombre) + ")"])]), " ", _vm._h('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editandoTarea === index),
        expression: "editandoTarea===index"
      }, {
        name: "model",
        rawName: "v-model",
        value: (tarea.titulo),
        expression: "tarea.titulo"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(tarea.titulo)
      },
      on: {
        "blur": function($event) {
          _vm.editandoTarea = null, _vm.editarTarea(tarea)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          tarea.titulo = $event.target.value
        }
      }
    }), " ", (_vm.usuarioActivo != null) ? _vm._h('div', [(tarea.uid == _vm.usuarioActivo.uid) ? _vm._h('div', {
      staticClass: "float-xs-right"
    }, [_vm._h('a', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.editandoTarea = index
        }
      }
    }, [_vm._m(1, true)]), " ", _vm._h('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editandoTarea === index),
        expression: "editandoTarea===index"
      }],
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.editandoTarea = null, _vm.editarTarea(tarea)
        }
      }
    }, [_vm._m(2, true)]), " ", _vm._h('a', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.actualizarEstadoTarea(true, tarea)
        }
      }
    }, [_vm._m(3, true)]), " ", _vm._h('a', {
      staticClass: "btn btn-outline-success btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.actualizarEstadoTarea(false, tarea)
        }
      }
    }, [_vm._m(4, true)]), " ", _vm._h('a', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.eliminarTarea(tarea)
        }
      }
    }, [_vm._m(5, true)])]) : _vm._e()]) : _vm._e()])])
  }), " ", _vm._h('pre', [_vm._s(_vm.$data)])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })
},function (){var _vm=this;
  return _vm._h('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  })
},function (){var _vm=this;
  return _vm._h('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })
},function (){var _vm=this;
  return _vm._h('i', {
    staticClass: "fa fa-undo",
    attrs: {
      "aria-hidden": "true"
    }
  })
},function (){var _vm=this;
  return _vm._h('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c48a992!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Todolist.vue
// module id = 51
// module chunks = 2